// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9f84bc3e","952":"53ef5857"}[chunkId] + ".chunk.js";
};